import { createSlice } from '@reduxjs/toolkit';
import { UserWithProjects } from '../../models/User';
import { RootState } from '../store';

interface UserState {
  user: UserWithProjects | null;
  token: string | null;
}

const initialState: UserState = {
  user: null,
  token: null,
};

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    setUser: (state, action: { payload: UserWithProjects }) => {
      const user = action.payload;
      state.user = user;
    },
    setToken: (state, action: { payload: string }) => {
      const token = action.payload;
      state.token = token;
    },
    logOut: (state) => {
      state.user = null;
      state.token = null;
    },
  },
});

export const { setUser, setToken, logOut } = authSlice.actions;

export default authSlice;

export const selectCurrentUser = (state: RootState) => state.auth.user;
export const selectCurrentToken = (state: RootState) => state.auth.token;
